module.exports = __webpack_public_path__ + "img/nexo.515941c1.png";